var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5206 2.90991C9.21058 2.90991 6.52058 5.59991 6.52058 8.90991V11.7999C6.52058 12.4099 6.26058 13.3399 5.95058 13.8599L4.80058 15.7699C4.09058 16.9499 4.58058 18.2599 5.88058 18.6999C10.1906 20.1399 14.8406 20.1399 19.1506 18.6999C20.3606 18.2999 20.8906 16.8699 20.2306 15.7699L19.0806 13.8599C18.7806 13.3399 18.5206 12.4099 18.5206 11.7999V8.90991C18.5206 5.60991 15.8206 2.90991 12.5206 2.90991Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3699 3.19994C14.0599 3.10994 13.7399 3.03994 13.4099 2.99994C12.4499 2.87994 11.5299 2.94994 10.6699 3.19994C10.9599 2.45994 11.6799 1.93994 12.5199 1.93994C13.3599 1.93994 14.0799 2.45994 14.3699 3.19994Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5195 19.0601C15.5195 20.7101 14.1695 22.0601 12.5195 22.0601C11.6995 22.0601 10.9395 21.7201 10.3995 21.1801C9.85953 20.6401 9.51953 19.8801 9.51953 19.0601",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.727dd44b5e063b8390e8372bbdbddf58.svg";
export { ForwardRef as ReactComponent };